// W-0829 — Grid mestre de Tipos de Resultado de Atendimento + filtro (código/descrição).
// Fonte Delphi: UResultadoAtend.pas (grid superior). Colunas: codigo (read-only), descricao,
// paga_label. SEM coluna/filtro de Cobranca (ADR-004 — filtro morto desde 07/05/2020).
// Filtro: radio "Por código" (int, valida "Parâmetro inválido." inline) / "Por descrição" (LIKE),
// debounce ~300ms. Reusa TabelaDinamica.

import React, { useState, useRef, useEffect } from 'react';
import { Card, Button, Form, Row, Col } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import Tabela from '~/Components/TabelaDinamica/Tabela';

const MSG_PARAMETRO_INVALIDO = 'Parâmetro inválido.';

const GridTipos = ({
  tipos,
  tipoSelecionado,
  onSelecionarTipo,
  onFiltrar,
  onIncluir,
  onEditar,
  onExcluir,
}) => {
  const [tipoBusca, setTipoBusca] = useState('descricao'); // 'codigo' | 'descricao'
  const [texto, setTexto] = useState('');
  const [erroFiltro, setErroFiltro] = useState('');
  const debounceRef = useRef(null);

  // Debounce ~300ms sobre o texto + modo de busca. Modo código exige inteiro.
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      if (tipoBusca === 'codigo' && texto.trim() !== '') {
        const n = Number(texto.trim());
        if (!Number.isInteger(n)) {
          setErroFiltro(MSG_PARAMETRO_INVALIDO);
          return; // não chama API com valor não-inteiro
        }
      }
      setErroFiltro('');
      onFiltrar(texto.trim(), tipoBusca);
    }, 300);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [texto, tipoBusca]);

  const colunas = [
    { title: 'Código', key: 'codigo', align: 'right', width: '110px' },
    { title: 'Descrição', key: 'descricao' },
    { title: 'Paga Comissão', key: 'paga_label', align: 'center', width: '140px' },
  ];

  // id estável p/ a key interna da TabelaDinamica (codigo do Tipo é único).
  const dados = (tipos || []).map((t) => ({ ...t, id: `tipo-${t.codigo}` }));

  const temSelecao = !!tipoSelecionado;

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: 8 }}>
        <strong>Tipos de Resultado de Atendimento</strong>
        <div className="d-flex" style={{ gap: 8 }}>
          <Button variant="success" size="sm" onClick={onIncluir}>
            <FaPlus /> Incluir
          </Button>
          <Button
            variant="primary"
            size="sm"
            disabled={!temSelecao}
            onClick={() => temSelecao && onEditar(tipoSelecionado)}
          >
            <FaEdit /> Editar
          </Button>
          <Button
            variant="danger"
            size="sm"
            disabled={!temSelecao}
            onClick={() => temSelecao && onExcluir(tipoSelecionado)}
          >
            <FaTrash /> Excluir
          </Button>
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        <Row className="align-items-end mb-2">
          <Col xs="auto">
            <Form.Check
              inline
              type="radio"
              id="ra-busca-descricao"
              label="Por descrição"
              checked={tipoBusca === 'descricao'}
              onChange={() => {
                setTipoBusca('descricao');
                setErroFiltro('');
              }}
            />
            <Form.Check
              inline
              type="radio"
              id="ra-busca-codigo"
              label="Por código"
              checked={tipoBusca === 'codigo'}
              onChange={() => {
                setTipoBusca('codigo');
                setErroFiltro('');
              }}
            />
          </Col>
          <Col xs={12} sm={6} md={4}>
            <Form.Control
              size="sm"
              type={tipoBusca === 'codigo' ? 'number' : 'text'}
              placeholder={tipoBusca === 'codigo' ? 'Código...' : 'Descrição...'}
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
            />
            {erroFiltro && <Form.Text className="text-danger">{erroFiltro}</Form.Text>}
          </Col>
        </Row>
        <Tabela
          colunas={colunas}
          dados={dados}
          fontSize="13px"
          cliqueLinha={(item) => onSelecionarTipo(item)}
          linhaSelecionada={(item) => tipoSelecionado && item.codigo === tipoSelecionado.codigo}
        />
      </Card.Body>
    </Card>
  );
};

export default GridTipos;
